import {
    Component,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
} from '@angular/core';

import {
    CmpsInsightCoachingPerformanceData,
    CmpsInsightCoachingPerformanceDropDownContent,
} from './insight-coaching-performance.metadata';
@Component({
    selector: 'cmps-insight-coaching-performance',
    template: `
        <div>
            <div class="cmps-insight-coaching-performance--row">
                <div class="cmps-insight-coaching-performance--column">
                    <div class="cmps-insight-coaching-performance--label">
                        <span>{{ label }}</span>
                    </div>
                </div>
                <div class="cmps-insight-coaching-performance--column">
                    <div
                        class="cmps-insight-coaching-performance--progress-bar"
                    >
                        <ng-container *ngFor="let i of data">
                            <ng-template #performanceTooltip>
                                <ng-container *ngFor="let n of i.tooltipData">
                                    <div
                                        class="cmps-insight-coaching-performance--tooltip-content"
                                    >
                                        <p
                                            class="cmps-insight-coaching-performance--child-title"
                                        >
                                            {{ n.title }}
                                        </p>
                                        <p
                                            class="cmps-insight-coaching-performance--child-number"
                                        >
                                            {{ n.number }}
                                        </p>
                                    </div>
                                </ng-container>
                            </ng-template>
                            <div
                                class="cmps-insight-coaching-performance--progress-bar-filled"
                                [cmpsTooltipTrigger]="performanceTooltip"
                                placement="top-center"
                                [style.width]="i.percent"
                                [style.backgroundColor]="i.backgroundColor"
                            >
                                <span>{{ i.labelValue }}</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="cmps-insight-coaching-performance--column">
                    <div
                        class="cmps-insight-coaching-performance--dots"
                        *ngIf="isParentPillar"
                    >
                        <cmps-icon svgIcon="__internal:dots"></cmps-icon>
                        <div
                            class="cmps-insight-coaching-performance--dropdown"
                        >
                            <ng-container
                                *ngFor="
                                    let item of dropdownContent;
                                    let i = index
                                "
                            >
                                <div
                                    class="cmps-insight-coaching-performance--dropdown-content"
                                    (click)="selectedValue.emit(item)"
                                >
                                    <a>{{ item.title }}</a>
                                    <cmps-icon
                                        class="cmps-insight-coaching-performance--chevron-right"
                                        *ngIf="item.subMenu.length > 0"
                                        svgIcon="__internal:chevron-right"
                                    ></cmps-icon>
                                    <div
                                        [ngClass]="{
                                            'cmps-insight-coaching-performance--dropdown-submenu':
                                                item.subMenu.length > 0,
                                            'cmps-insight-coaching-performance--dropdown-no-submenu':
                                                item.subMenu.length === 0
                                        }"
                                    >
                                        <ng-container
                                            *ngFor="
                                                let j of item.subMenu;
                                                let n = index
                                            "
                                        >
                                            <div
                                                class="cmps-insight-coaching-performance--dropdown-content cmps-insight-coaching-performance--dropdown-submenu-item"
                                                (click)="
                                                    $event.stopPropagation();
                                                    selectedValue.emit(j)
                                                "
                                                [class.cmps-insight-coaching-performance--is-checked]="
                                                    j.isChecked
                                                "
                                            >
                                                <cmps-icon
                                                    *ngIf="j.isChecked"
                                                    class="cmps-insight-coaching-performance--check"
                                                    svgIcon="__internal:check"
                                                    ><span>{{
                                                        j.value
                                                    }}</span></cmps-icon
                                                >
                                                <span>{{ j.value }}</span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div
                        class="cmps-insight-coaching-performance--close"
                        *ngIf="!isParentPillar"
                    >
                        <button
                            class="cmps-insight-coaching-performance--close-btn"
                            cmpsIconButton
                            (click)="closeAction.emit($event)"
                        >
                            <cmps-icon
                                class="cmps-insight-coaching-performance--close-button"
                                svgIcon="__internal:close"
                            ></cmps-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="row-body">
                <ng-container *ngTemplateOutlet="childPillar"></ng-container>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-insight-coaching-performance',
        '[class.cmps-insight-coaching-performance--total-performance]':
            'isTotalPerformance',
    },
})
export class CmpsInsightCoachingPerformanceComponent {
    @Input() isTotalPerformance: boolean;
    @Input() isParentPillar: boolean;
    @Input() label: string;
    @Input() dropdownContent: CmpsInsightCoachingPerformanceDropDownContent[];
    @Input() data: CmpsInsightCoachingPerformanceData;
    @Input() childPillar: TemplateRef<any> | null;

    @Output() selectedValue: EventEmitter<MouseEvent | KeyboardEvent>;
    @Output() closeAction: EventEmitter<MouseEvent | KeyboardEvent>;

    constructor() {
        this.selectedValue = new EventEmitter();
        this.closeAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.selectedValue.complete();
        this.closeAction.complete();
    }
}
